import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="pt-24 md:pt-32">
      <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-500">
          <i className="ri-flower-fill" />
        </span>
        <p className="mt-6 font-heading text-5xl font-bold text-primary-500 md:text-6xl">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
          这个页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          {location.pathname}
        </p>
        <p className="mt-4 max-w-md text-sm text-foreground-600">
          你访问的页面可能已被移除或链接有误。回到首页，继续探索心动的百合影视作品吧。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-4-line" />
            </span>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </div>
  );
}